<!-- <div class="schedule-modal">
    <div mat-dialog-content>
      <div>{{message}}</div>
    </div>
    <div mat-dialog-actions>
      <button mat-button *ngFor="let action of actions" (click)="handleClick(action.value)">
        {{action.name}}
      </button>
    </div> -->



    <div class="dialog-md">
        <i class="material-icons popupClose" mat-dialog-close>clear</i>
        <div class="dialogTitle center-align loginTtile">
          <div class="icons text-center">
            <i class="fas fa-exclamation-triangle"></i>
          </div>
          <!-- <h5 class="titletext">Are you sure ?</h5> -->
          <h5 class="titletext"> {{message}}</h5>
        </div>
        <br>
        <mat-dialog-content class="mat-typography">
          <!-- <p class="mb-4 center ">Do you want to delete ?</p> -->
          <div class="btnsWidget text-right mt-2">
            <!-- <button (click)=confirmDelete() class="btn btn-primary btn-sm">Yes</button> -->
            <button class="actionsbtns" matRipple *ngFor="let action of actions" (click)="handleClick(action.value)">
                {{action.name}}
              </button>
    
          </div>
        </mat-dialog-content>
      </div>
